<section class="w-full overflow-x-hidden bg-bg-base text-text-primary min-h-screen">
  <div class="mx-auto w-full max-w-[1800px] px-3 py-4 sm:px-5 sm:py-6 lg:px-8 lg:py-8">
    <div class="space-y-4 sm:space-y-6">
      <div class="">
        <app-developer-header></app-developer-header>
      </div>

      <div class="overflow-hidden rounded-2xl sm:rounded-3xl border border-border-strong bg-surface-base shadow-2xl">
        <app-developer-tabs-navigation></app-developer-tabs-navigation>
        <app-developer-tabs-content></app-developer-tabs-content>
      </div>
    </div>
  </div>
</section>
